import * as React from 'react'
import styles from './index.module.css'

const FormattingColumn = ({
  children,
  style,
}: {
  children: React.ReactNode
  style: Record<string, any>
}): React.ReactElement<'div'> => {
  return (
    <div className={styles.contentEditorFormattingBlockColumn} style={style}>
      {children}
    </div>
  )
}

export default FormattingColumn
